export enum OrganizationRole {
  ADMIN = 'admin',
  USER = 'user',
}

export enum ViewAccessType {
  ALLOWED = 'allowed',
  DENIED = 'denied',
}

export enum ViewType {
  cohortMarketingPerformance = 'cohortMarketingPerformance',
  calendarInsights = 'calendarInsights',
  cohortChart = 'cohortChart',
  calendarChart = 'calendarChart',
  cohortScanner = 'cohortScanner',
  cohortRetention = 'cohortRetention',
  roiBreakdown = 'roiBreakdown',
  webLinks = 'webLinks',
  integrations = 'integrations',
  productsCatalog = 'productsCatalog',
}

export enum ContractType {
  fixedProducts = 'fixed_products',
  unlimitedProducts = 'unlimited_products',
}

export type ViewsRestrictions = Partial<Record<ViewType, ViewAccessType>>;

export interface Profile {
  id: string;
  email: string;
  organization: {
    id: string;
    name: string;
    currency: string;
    paymentOverdue: boolean;
    webhookHash: string;
    contractType: ContractType;
  };
  viewsRestrictions: ViewsRestrictions;
  isActive: boolean;
  role: OrganizationRole;
  analyticsId: string;
}
